import { useTranslation } from 'react-i18next';
import styles from './TimePeriodSelect.module.scss';

export const DATE_RANGES = {
  "24h": "now - duration 'P1D'/now",
  "week": "now - duration 'P7D'/now",
  "month": "now - duration 'P30D'/now",
} as const;

export type TimePeriodT = keyof typeof DATE_RANGES;

interface TimePeriodSelectProps {
  timePeriod: TimePeriodT;
  setTimePeriod: (period: TimePeriodT) => void;
}

export const TimePeriodSelect = ({ timePeriod, setTimePeriod }: TimePeriodSelectProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles.form_select}>
      <select
        value={timePeriod}
        onChange={(e) => setTimePeriod(e.target.value as TimePeriodT)}
        className={styles.date_select}
      >
        <option value="24h">{t('PortArrivalsDateOption_24h')}</option>
        <option value="week">{t('Week')}</option>
        <option value="month">{t('Month')}</option>
      </select>
    </div>
  );
};
